import React from "react"
import { FormField } from "../../styles/Form"
import { SubmitButton as StyledButton } from "@nvdb-rapport/shared/src/styled/Button"
interface SubmitButton {
  disabled?: boolean
}

export default function SubmitButton({ disabled = false }: SubmitButton) {
  return (
    <FormField className="language">
      <StyledButton type="submit" disabled={disabled}>
        Hent veglister
      </StyledButton>
    </FormField>
  )
}
